/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
	selector: "cb-layout-row",
	templateUrl: "./layout-row.component.html",
	styleUrl: "./layout-row.component.scss",
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutRowComponent {
	public readonly scrollable = input(false);
	public readonly align = input<"start" | "center" | "end">("start");
	public readonly justify = input<"start" | "center" | "end">("start");

	public readonly alignStyle = computed(() => {
		switch (this.align()) {
			case "center":
				return "center";
			case "end":
				return "flex-end";
			default:
				return "flex-start";
		}
	});

	public readonly justifyStyle = computed(() => {
		switch (this.justify()) {
			case "center":
				return "center";
			case "end":
				return "flex-end";
			default:
				return "flex-start";
		}
	});

}
